import Input from '@/components/atoms/input';
import * as ViewModel from '@/core/presenter/viewModel';

interface IProps {
  sendAsset: string;
  isWritting: boolean;
  curculateKrw: string;
  selectedAsset: ViewModel.IAsset | undefined;
  onChangeSelectedAsset: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onClickResetAmountBtn: () => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const SendCheckAmountBox = ({
  sendAsset,
  isWritting,
  selectedAsset,
  curculateKrw,
  onChangeSelectedAsset,
  onClickResetAmountBtn,
  onKeyPress,
}: IProps) => {
  return (
    <div id="amountContainer" className="amount-container" style={{ display: isWritting ? 'flex' : 'none' }}>
      <label>보낼 수량:</label>
      <div className="amount-group">
        <div className="amount-display">
          <div className="left-top">
            <Input
              type="text"
              value={sendAsset}
              onChange={onChangeSelectedAsset}
              onKeyPress={onKeyPress}
              id="amountInput"
              placeholder="0"
              style={{ width: '72px' }}
              validatorType={ViewModel.InputValidatorType.NUMBER_ONLY}
            />
            <span id="currencyLabel">{selectedAsset?.symbol}</span>
          </div>
          <span className="krw" id="krwEquivalent">
            {curculateKrw} 원
          </span>
        </div>
        <div className="right">
          <i
            className="bi bi-arrow-counterclockwise reset-icon ml-gray"
            title="초기화"
            onClick={onClickResetAmountBtn}
          ></i>
        </div>
      </div>
    </div>
  );
};

export default SendCheckAmountBox;
